module.exports = __webpack_public_path__ + "static/media/Group_3653.ab457499.png";